import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  RegisterCloseButton,
  ModalLogoWrapper,
  ModalLogoABC,
  ModalLogoPUB,
  ModalLogoFUN,
  ModalLogoCAC,
  ModalLogoHYC,
  ModalLogoYET,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";

export const CasinoClosingDialog = ({ showModal, setModal, skin }) => {
  const { t } = useTranslation("");

  return (
    <StyledModal isOpen={showModal}>
      <RegisterCloseButton onClick={() => setModal(false)} />
      <ModalLogoWrapper>
        {skin === "abc" && <ModalLogoABC />}
        {skin === "pub" && <ModalLogoPUB />}
        {skin === "yet" && <ModalLogoYET />}
        {skin === "fun" && <ModalLogoFUN />}
        {skin === "cac" && <ModalLogoCAC />}
        {skin === "hyc" && <ModalLogoHYC />}
      </ModalLogoWrapper>
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{ __html: t("label_casino_closing") }}
      ></StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => setModal(false)}
        >
          {t("label_ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
